import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Tag,
  DatePicker,
  Tooltip,
  Avatar,
  Image,
} from "antd";
import React, { useState, useEffect, useContext } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import ShowTotal from "../../components/ShowTotal";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import AddFrom from "./AddFrom";
import ConfirmationBox from "../../components/ConfirmationBox";
import lang from "../../helper/lang";
import { AuthContext } from "../../context/AuthContext";
import { USERTYPE } from "../../constants/conts";
import FilterBar, { FilterBarFilters } from "../../components/FilterBar";
const { RangePicker } = DatePicker;

function Index() {
  const sectionName = lang("Discount");
  const routeName = "discount";

  const api = {
    status: apiPath.statusDiscount,
    addEdit: apiPath.addEditContest,
    list: apiPath.listDiscount,
  };
  const { userProfile, userPermission } = useContext(AuthContext);
  const { request } = useRequest();
  const { showConfirm } = ConfirmationBox();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [branchStatus, setBranchStatus] = useState();
  const [branchActive, setBranchActive] = useState();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [showFilters, setShowFilters] = useState(false);
  const isAddPermissionGranted = userPermission?.BranchSection?.includes("add");
  const addPermissionTooltip = isAddPermissionGranted
    ? ""
    : "Permission Not Granted";
  const addDisabledAttribute = isAddPermissionGranted ? "" : "disabled";
  const columns = [
    {
      title: `Discount Code`,
      dataIndex: "code",
      key: "code",
      width: "10%",
      render: (_, { code }) => {
        return (
          code ? code : "-"
        )
      }
    },
    {
      title: `Discount Type`,
      dataIndex: "type",
      key: "type",
      width: "10%",
    },
    {
      title: "Discount Amount (₹)",
      dataIndex: "discount",
      key: "discount",
      width: "10%",
      render: (text) => `₹ ${" "}${text}`,
    },

    {
      title: `Start Date`,
      key: "start_date",
      dataIndex: "start_date",
      width: "10%",
      render: (text) => moment(text).format("DD-MMM-YYYY"),
    },
    {
      title: `End Date`,
      key: "end_date",
      dataIndex: "end_date",
      width: "10%",
      render: (text) => moment(text).format("DD-MMM-YYYY"),
    },
    {
      title: `Description`,
      key: "description",
      dataIndex: "description",
      render: (_, { description }) => {
        const descr = description || "-";
        const truncatedDescription = descr.split(" ").slice(0, 8).join(" ");
        return (
          <span>
            {descr.split(" ").length > 8 ? `${truncatedDescription}...` : descr}
          </span>
        );
      },
    },
    {
      title: `${lang("Status")}`,
      key: "is_active",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "Inactive",
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        let color = is_active ? "green" : "red";
        return (
          <a>
            <Tag
              onClick={() =>
                showConfirm({
                  record: _id,
                  path: api.status,
                  onLoading: () => setLoading(true),
                  onSuccess: () => setRefresh((prev) => !prev),
                })
              }
              color={color}
              key={is_active}
            >
              {is_active ? "Active" : "Inactive"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: `${lang("Registered On")}`,
      key: "created_at",
      dataIndex: "created_at",
      render: (text) => moment(text).format("DD-MMM-YYYY"),
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    },
    {
      title: `${lang("Action")}`,
       
      render: (_, record) => {
        return (
          <>
            <Tooltip
              title={`${lang("Update")} ` + sectionName}
              color={"purple"}
              key={"update" + routeName}
            >
              <Button
                onClick={() => {
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <i className="fa fa-light fa-pen"></i>
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];
  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, startDate, endDate]);
  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.is_active : branchActive;
    const filterAvailable = filters ? filters.is_available : branchStatus;
    setBranchStatus(filterAvailable);
    setBranchActive(filterActive);
    setList(() => []);
    request({
      url:
        api.list +
        `?status=${filterActive ? filterActive.join(",") : ""
        }&available_status=${filterAvailable ? filterAvailable.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&start_date=${startDate ? startDate : ""}&end_date=${endDate ? endDate : ""
        }`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(() => data.docs);
        console.log(list);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.totalDocs,
          pageSize: Number(data.limit),
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };
  const handleChangeDate = (e) => {
    setPagination({ current: 1, pageSize: pagination.pageSize });
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };
  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + ` ${lang("Manager")}`}
              extra={
                <FilterBar
                  showFilters={showFilters}
                  onToggle={() => setShowFilters((v) => !v)}
                  rightContent={
                    userProfile &&
                    userProfile?.user_type === USERTYPE.SUB_ADMIN ? (
                      <Tooltip
                        title={addPermissionTooltip}
                        color={"red"}
                        key={"view" + routeName}
                      >
                        <Button
                          onClick={(e) => setVisible(true)}
                          disabled={addDisabledAttribute}
                        >
                          {lang("Add")} {sectionName}
                        </Button>
                      </Tooltip>
                    ) : (
                      <Button onClick={(e) => setVisible(true)}>
                        {lang("Add")} {sectionName}
                      </Button>
                    )
                  }
                />
              }
            >
              {showFilters && (
                <FilterBarFilters>
                  <RangePicker
                    className="d-inline-block"
                    disabledDate={(current) => current.isAfter(Date.now())}
                    onChange={handleChangeDate}
                  />
                </FilterBarFilters>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  marginBottom: "10px",
                  flexWrap: "wrap",
                }}
              >
                <h4 className="text-right mb-0">
                  {" "}
                  {pagination.total
                    ? ShowTotal(pagination.total)
                    : ShowTotal(0)}{" "}
                </h4>
              </div>

              <div className="table-responsive customPagination customPaginationmain-newwwww">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {visible && (
        <AddFrom
          type={sectionName}
          path={api.addEdit}
          sectionName={sectionName}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

export default Index;
